const gMapsController = async function () {
    const homepage = document.querySelector('.acf-map') !== null;

    if (homepage) {
        const {
            Loader,
        } = require('@googlemaps/js-api-loader')

        const loader = new Loader({
            apiKey: "AIzaSyDQfTi39U-bGEjy3p30hnyPsy17sLGBMh0",
            version: "weekly",
            libraries: ["places"]
        });
        const google = await loader.load();
        const acf_map = document.querySelector('.acf-map');
        const acf_map_marker = document.querySelector('.acf-map .marker');

        const el1 = parseFloat(acf_map_marker.getAttribute('data-lat'));
        const el2 = parseFloat(acf_map_marker.getAttribute('data-lng'));

        const map = new google.maps.Map(acf_map, {

            center: {
                lat: el1,
                lng: el2

            },
            zoom: 18,
            disableDefaultUI: true,
            zoomControl: true,
        });
        const image =
              "../../wp-content/themes/urbanTheme/assets/images/marker.png";
        const beachMarker = new google.maps.Marker({
            position: { lat: el1, lng: el2},
            map,
            icon: image,
        });

    }
}

export const init = gMapsController;